export function AdminEmail (pConfig)
{
  return (
  {
    name : 'EditorToolbarComposeEmailConfig',
    GroupsChange :
    {
      BlockStylesMini :
      {
        visible: false
      },

      HistoryActionsMini:
      {
        visible : false
      },

      TextAlignMini:
      {
        visible : false
      },

      FontColorsMini:
      {
        visible : false
      },

      TextActionsMini:
      {
        visible : false
      },

      CopyPasteMini:
      {
        visible : false
      },

      HTMLMini :
      {
        visible: false
      },

      BigSizeButtonsMini :
      {
        visible: false
      },

      BlockStyles :
      {
        visible: false
      },

      FontColors :
      {
        visible: false
      },

      BigSizeButtons :
      {
        visible: false
      },

      BigSizeButtonsEvent :
      {
        visible: false
      }
    }
  });
}